import {Base} from "@/api/Base"

export class GiList extends Base {
    path = "gi/list"
}